import React from 'react';

import VistaPersonas from '../Compartidas/VistaPersonas';

import AutoresBlogsHelper from '../../Helpers/AutoresBlogs';

const HELPER = {
    obtener: AutoresBlogsHelper.obtnenreAutores,
    obtenerUso: AutoresBlogsHelper.obtenerUso,
    agregar: AutoresBlogsHelper.agregarAutor,
    editar: AutoresBlogsHelper.editarAutor,
    eliminar: AutoresBlogsHelper.eliminarAutor
};

const USADO_EN = { singular: 'blog', plural: 'blogs' };

const TEXTOS = {
    agregar: 'Agregar autor',
    editar: 'Editar autor',
    ayuda: 'Haz clic en un autor para editarlo. Los que firman algún blog no se pueden eliminar.',
    buscar: 'Buscar por nombre o certificado',
    vacio: 'Aún no hay autores de blogs.',
    ubicacion: 'Aparece debajo del título de cada blog que firma.',
    certificado: 'Certificado',
    ayudaCertificado: 'Se muestra debajo del nombre, ej. CAAV.',
    enUso: cuantos => `Firma ${cuantos}. Para eliminarlo, primero asigna otro autor a esos blogs.`
};

// Las fotos viejas están en autores_blogs/; las nuevas van a imagenes/autores-blogs/
const CARPETAS_PROPIAS = ['imagenes%2Fautores-blogs%2F', 'autores_blogs%2F'];

const AutoresBlogs = () => (
    <VistaPersonas
        helper={HELPER}
        seccion='Blogs'
        encabezado='Autores de blogs'
        textos={TEXTOS}
        usadoEn={USADO_EN}
        carpeta='imagenes/autores-blogs/'
        carpetasPropias={CARPETAS_PROPIAS}
        prefijo='autor'
    />
);

export default AutoresBlogs;
